import { makeStyles } from '@mui/styles';
import { FunctionField, FunctionFieldProps } from 'react-admin';
import React from 'react';
import { Tooltip } from 'antd';
import { clsx } from 'clsx';

export const CxInvoiceUpdatedByField = (props: Partial<FunctionFieldProps>) => {
  const cls = useStyles();

  return (
    <FunctionField {...props} render={(record: any) => {
      const uploadedBy: any = record[props.source || 'uploadedBy'];
      let letter = 'U';
      let text = 'Uploaded by user';

      if (!uploadedBy) {
        return '';
      }

      if (uploadedBy.type === 'admin') {
        letter = 'A';
        text = 'Uploaded by admin';
      } else if (uploadedBy.type === 'manager') {
        letter = 'M';
        text = 'Uploaded by manager';
      }

      return record ? (
        <div className={cls.wrap}>
          <div className={clsx(
            cls.label,
            letter === 'A' && cls.labelA,
            letter === 'U' && cls.labelU,
            letter === 'M' && cls.labelM,
          )}>
            <Tooltip title={text} placement="top" color="#042E6B">{letter}</Tooltip>
          </div>
          <div className={cls.link}>{uploadedBy?.name}</div>
        </div>
      ) : null;
    }}
    />
  );
};

const useStyles = makeStyles({
  wrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: 12,
  },
  label: {
    flex: '0 0 20px',
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: '1px solid #ccc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  labelA: {
    borderColor: '#dd482e',
    background: 'rgba(221, 72, 46, 0.6)',
    color: 'white',
  },
  labelU: {
    borderColor: '#042e6b',
    background: 'rgba(4, 46, 107, 0.6)',
    color: 'white',
  },
  labelM: {
    borderColor: '#73BA47',
    background: 'rgba(115, 186, 71, 0.6)',
    color: 'white',
  },
  link: {

  },
});
